import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'
import { Dispatch } from 'redux'

import {
  fetchFeaturedPageDataBySite,
  IFeaturedPageSeoMetaData,
  onBeforeFeaturePageView
} from '../../common/actions/featurePage'
import { getBookmarksForItems } from '../../common/actions/user/bookmark'
import { IRootState } from '../../common/reducers'
import { IEnhancedLocation } from '../../common/reducers/reactRouterLocation'
import { decorateSearchResult } from '../../common/selectors/searchResults'
import { IPageComponent } from '../../typings/pageComponent'
import { IItem } from '../../typings/searchResults'
import FeaturedPage from '../pages/feature/featurePage'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  metadata?: IFeaturedPageSeoMetaData
  featuredItems: IItem[]
  location: IEnhancedLocation
  experimentsReady: boolean
  isLoading: boolean
  currentSite: Site
  hasLoadAttempt: boolean
}

interface IDispatchProps {
  getBookmarksForItems: (itemIds: number[]) => Promise<any>
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const {
    featuredPage: { featuredItems: featuredItemsMatches, isLoading, metadata }
  } = state
  const { location } = state.router
  const { experimentsReady } = state.experiments
  const { currentSite } = state.common
  const { hasLoadAttempt } = state.user

  const featuredItems =
    (featuredItemsMatches &&
      featuredItemsMatches.matches.map(match =>
        decorateSearchResult(state, match)
      )) ||
    []

  return {
    metadata,
    featuredItems,
    location,
    experimentsReady,
    currentSite,
    isLoading,
    hasLoadAttempt
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
): IDispatchProps => {
  return {
    getBookmarksForItems: (itemIds: number[]) =>
      dispatch(getBookmarksForItems(itemIds))
  }
}

export type Props = IOwnProps & IStateProps & IDispatchProps

const createFeaturePageContainer = (component: React.ComponentType<Props>) => {
  const pageComponent: IPageComponent<Props> = component as IPageComponent<
    Props
  >

  pageComponent.loadData = (store, location, apiUrlPrefix) =>
    store.dispatch(fetchFeaturedPageDataBySite(location, apiUrlPrefix))

  pageComponent.onBeforePageView = store =>
    store.dispatch(onBeforeFeaturePageView())

  return connect<IStateProps, IDispatchProps, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(pageComponent)
}

export default createFeaturePageContainer(FeaturedPage)
